'use client';

import { cn } from '@workspace/ui/lib/utils';
import { useState } from 'react';
import { Subscribe } from './buttons/Subscribe';
import { Donate } from './buttons/Donate';
import { IProfile, PaypalRecipientStatus } from 'types/src/types';
import { IUIProfile } from '@/src/types/IUIProfile';
import { Follow } from './buttons/Follow';

type Props = {
  isMobileView: boolean;
  authenticatedUser?: IUIProfile | null;
  creatorProfile: IProfile;
  isMyProfile: boolean;
  isGoal?: boolean;
};

export const ProfileButtons = ({
  isMobileView,
  isMyProfile,
  authenticatedUser,
  isGoal,
  creatorProfile: {
    id,
    fullName,
    avatarUrl,
    isFollowing,
    subscribedInfo,
    hasTier,
    stripeAccountId,
    isStripeConnected = false,
    uniqueLink,
    currentTierPrice,
    payment,
    isPartner,
  },
}: Props) => {
  const [isLocalFollow, setIsLocalFollow] = useState(isFollowing);
  const [isLocalSubscribe, setIsLocalSubscribe] = useState(
    subscribedInfo.isSubscribed,
  );

  const paymentProvider = payment?.provider ?? 'none';
  const canShowMonetization = paymentProvider !== 'none';

  const isAnon = authenticatedUser?.type === 'anonymous';
  const authedUserId = authenticatedUser?.id as number;

  return (
    <div
      className={cn('flex gap-2 flex-col-reverse my-2 p-0 px-3', {
        'xl:flex-row md:my-6 md:px-2': !isMobileView,
      })}
    >
      <Follow
        isFollow={isLocalFollow}
        setIsFollow={setIsLocalFollow}
        creatorId={id}
        isAnonymous={isAnon}
        isMyProfile={isMyProfile}
        className={!isMobileView ? 'xl:w-1/3' : ''}
      />

      {canShowMonetization && (
        <div
          className={cn('flex justify-between w-full items-center', {
            'xl:w-2/3': !isMobileView,
          })}
        >
          {payment.isEnabled && hasTier && (
            <Subscribe
              creatorId={id}
              userId={authedUserId}
              stripeAccount={stripeAccountId}
              creatorName={fullName || ''}
              profileUniqueLink={uniqueLink}
              isSubscribe={isLocalSubscribe}
              subscribedInfo={subscribedInfo}
              setIsSubscribe={setIsLocalSubscribe}
              isAnonymous={isAnon}
              price={currentTierPrice}
              isMyProfile={isMyProfile}
              className={isGoal ? 'w-full' : ''}
              isGoal={isGoal}
              paymentProvider={paymentProvider}
              paypalStatus={
                payment?.paypalStatus as PaypalRecipientStatus | null
              }
              isCreatorPartner={isPartner}
            />
          )}

          {!isGoal && (
            <Donate
              creatorId={id}
              userId={authedUserId}
              creatorName={fullName || ''}
              profileUniqueLink={uniqueLink}
              creatorImage={avatarUrl || ''}
              isAnonymous={isAnon}
              isMyProfile={isMyProfile}
              className={!isMobileView ? 'xl:w-1/2 mx-1' : ''}
              stripeAccount={
                paymentProvider === 'Stripe' ? stripeAccountId : undefined
              }
              paymentProvider={paymentProvider}
              paypalStatus={
                payment?.paypalStatus as PaypalRecipientStatus | null
              }
            />
          )}
        </div>
      )}
    </div>
  );
};
